import { TProductParams } from '../type'

// получение названия параметра картинок по id
export const getFieldNameByParamId = (
  id: number | string,
  parametersArray: TProductParams[],
): string => {
  const matchingParam = parametersArray.find(
    param => param.parameterValue.value === id,
  )
  return matchingParam?.name || ''
}
